import r from "../../shared-lib/braze-shared-lib.js";
import e from "../managers/braze-instance.js";
import ue from "../models/braze-event.js";
import t from "../models/request-result.js";
const s = {
  N: (o, n, s) => {
    var i;
    const a = new t(),
      l = e.aa();
    if (!l)
      return (
        r.j.info(
          `Not logging event with type "${o}" because the current session ID could not be found.`,
        ),
        a
      );
    const m = l.co();
    a.ve.push(
      new ue(
        s || (null === (i = e.ir()) || void 0 === i ? void 0 : i.getUserId()),
        o,
        new Date().valueOf(),
        m,
        n,
      ),
    );
    const u = e.l();
    return u && (a.O = u.bo(a.ve)), a;
  },
};
export default s;
